import { ReportsPage } from '@/components/reports/ReportsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/reports/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ReportsPage />;
}
